const _import = require('../import-' + process.env.NODE_ENV)

const shelveInfosRouter = [
  {
    path: '/shelveInfos/index',
    name: 'shelveInfosIndex',
    component: _import('shelveInfos/Index'),
    meta: {
      title: '货架棚格录入',
      keepAlive: true,
      auth: true
    }
  },
  {
    path: '/shelveInfos/site',
    name: 'shelveInfosSite',
    component: _import('shelveInfos/Site'),
    meta: {
      title: '商品棚格查询',
      auth: true
    }
  },
  {
    path: '/shelveInfos/audit',
    name: 'shelveInfosAudit',
    component: _import('shelveInfos/Audit'),
    meta: {
      title: '采购审核排面',
      auth: true
    }
  },
  {
    path: '/shelveInfos/adjustLogs',
    name: 'shelveInfosAdjustLogs',
    component: _import('shelveInfos/AdjustLogs'),
    meta: {
      title: '调整记录',
      auth: true
    }
  },
  {
    path: '/shelveInfos/editInfo',
    name: 'shelveInfosEditInfo',
    component: _import('shelveInfos/EditInfo'),
    meta: {
      title: '调整详情',
      auth: true
    }
  }
]

export default shelveInfosRouter



// WEBPACK FOOTER //
// ./src/router/shelveInfos/index.js